import { Component, inject } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  tap,
  filter,
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  of,
  catchError,
  take,
  combineLatest,
} from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { SearchService } from '@lcms/shared/search-lib';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'lcms-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss'],
})
export class SearchPageComponent {
  sanitizer = inject(DomSanitizer);
  searchService = inject(SearchService);
  router = inject(Router);
  activateRoute = inject(ActivatedRoute);
  // searchQ=this.searchService.searchKeyworld.value;
  isLoading = this.searchService.searching;
  // selectedCategory=new BehaviorSubject('');
  resultsCategories: any;
  currentQuery$ = this.activateRoute.queryParams
    .pipe(
      filter(
        (o: { query?: string }) =>
          !this.searchService.checkKeyword(o?.query || '')
      ),
      map((o: { query?: string }) => o.query),
      tap((term: any) => this.searchService.searchKeyworld.next(term)),
      take(1)
    )
    .subscribe();

  results$ = this.searchService.searchResult$.pipe(
    tap((res) => {
      this.resultsCategories = [
        {
          title: 'all',
          key: '',
          isActive: true,
          nbr: Object.values(res).reduce(
            (acc, temp: any) => acc + temp.length,
            0
          ),
        },
        ...Object.keys(res)
          .filter((rkey) => res[rkey].length > 0)
          .map((rkey) => ({
            title: rkey,
            key: rkey,
            isActive: false,
            nbr: res[rkey].length,
          })),
      ];
    })
  );

  handleActive(item: any) {
    this.resultsCategories = this.resultsCategories.map((res: any) =>
      res === item ? { ...res, isActive: true } : { ...res, isActive: false }
    );
    // this.selectedCategory.next(item?.key ?? '');
    this.searchService.setCheckedCategory((item?.key as string) || '');
  }

  search(event: any) {
    this.router.navigate([], {
      relativeTo: this.activateRoute,
      queryParams: { query: event.target.value },
      queryParamsHandling: 'merge',
    });
    this.searchService.searchByAnswer.next(false);
    if (event.key === 'Enter') {
      this.searchService.searchByAnswer.next(true);
    }

    if (!this.searchService.checkKeyword(event.target.value || '') || event.key === 'Enter' )
      this.searchService.searchKeyworld.next(event.target.value);
    // if(this.searchQ!== this.searchService.searchKeyworld.value)
  }
  getKeys(obj: any) {
    let keys = Object.keys(obj);
    return keys.sort((a, b) => a.localeCompare(b));
  }
}
